<script>
  const uniqueId = () => {
    return new Date() - 0 + "_" + Math.random().toString(36).substr(2, 9);
  };

  export default {
    name: "Slide",
    props: [
      "slideList",
      "autoplay",
      "autoplayDelay",
      "width",
      "height",
      "noPagination",
    ],
    data() {
      return {
        nowIndex: 0,
        maxIndex: this.slideList - 1,
        minIndex: 0,
        paginationCount: 0,
        dir: 0,
        startX: 0,
        startY: 0,
        autoplayId: false,
        moveX: 0,
        moveY: 0,
        interval: this.autoplayDelay || 3000,
        moveToken: false,
        readyIndex: false,
        isMove: false,
        toLeft: -1,
        toRight: -1,
        slideUid: uniqueId(),
      };
    },
    computed: {
      duration() {
        if (this.moveToken) return 0;
        if (this.moveX != 0) return 0.3;
        return this.distance != 0 ? 0.3 : 0;
      },
      distance() {
        if (this.moveToken) return this.moveX;
        return this.dir * this.width;
      },
      leftSide() {
        if (this.disabled) return -1;
        if (this.toRight > -1) return -1;
        if (this.toLeft > -1) return this.getIndex(this.toLeft);
        return this.getIndex(this.nowIndex - 1);
      },
      rightSide() {
        if (this.disabled) return -1;
        if (this.toLeft > -1) return -1;
        if (this.toRight > -1) return this.getIndex(this.toRight);
        return this.getIndex(this.nowIndex + 1);
      },
      scrollStyle() {
        return {
          "transform": `translate(${this.distance}px)`,
          "transition-duration": `${this.duration}s`,
        };
      },
      contextStyle() {
        return {
          width: `${this.width}px`,
          height: `${this.height}px`,
          right: '283px',
          top:'365px'
        };
      },
      disabled() {
        return this.slideList < 2;
      },
      enableButton() {
        return !this.disabled;
      },
    },
    watch: {
      slideList() {
        this.maxIndex = this.slideList - 1;
        this.nowIndex = 0;
        this.paginationCount = 0;
      },
      isMove(v) {
        if (this.autoplay) {
          if (v) {
            this.stop();
          }
          else {
            this.play();
          }
        }
      },
      autoplay(v) {
        if (!v) {
          this.stop();
        }
        else {
          this.play();
        }
      },
    },
    methods: {
      prev() {
        this.to(this.nowIndex - 1);
      },
      next() {
        this.to(this.nowIndex + 1);
      },
      to(index) {
        this.$emit("transitionstart");

        if (this.nowIndex === index || this.isMove) return;
        this.isMove = true;
        this.toIndex = index;
        this.paginationCount = this.getIndex(index);
        this.dir = index > this.nowIndex ? -1 : 1;

        this[`to${this.dir > 0 ? "Left" : "Right"}`] = this.getIndex(index);
      },
      play() {
        this.autoplayId = setInterval(() => {this.next();}, this.interval);
      },
      stop() {
        this.autoplayId && clearInterval(this.autoplayId);
      },
      transitionEnd() {
        this.dir = 0;
        this.isMove = false;
        this.nowIndex = this.getIndex(this.toIndex);
        this.startX = 0;
        this.startY = 0;
        this.moveX = 0;
        this.moveY = 0;
        this.toLeft = -1;
        this.toRight = -1;

        this.$emit("transitionend");
      },
      handleMouseDown(e) {
        if (this.disabled) return;
        if (this.isMove) return;
        this.moveToken = true;

        if (e.type.indexOf("touch") !== -1) {
          this.startX = e.changedTouches[0].pageX;
          this.startY = e.changedTouches[0].pageY;
        }
        else {
          this.startX = e.pageX;
          this.startY = e.pageY;
        }

      },
      handleMouseMove(e) {
        if (!this.moveToken) return;
        this.isMove = true;

        if (e.type.indexOf("touch") !== -1) {
          this.moveX = e.changedTouches[0].pageX - this.startX;
          this.moveY = e.changedTouches[0].pageY - this.startY;
        }
        else {
          this.moveX = e.pageX - this.startX;
          this.moveY = e.pageY - this.startY;
        }

        if (Math.abs(this.moveX) < Math.abs(this.moveY)) {
          e.preventDefault();
        }
      },
      handleMouseUp() {
        if (!this.moveToken) return;
        this.moveToken = false;

        if (Math.abs(this.moveX) > 50) {
          this.isMove = false;
          this.to(this.moveX > 0 ? this.nowIndex - 1 : this.nowIndex + 1);
        }
        else {
          this.toIndex = this.nowIndex;
        }
      },
      getIndex(index) {
        if (this.minIndex > index) {
          index = this.maxIndex;
        }
        if (this.maxIndex < index) {
          index = this.minIndex;
        }
        return index;
      },
      getClass(index) {
        let now = this.nowIndex == index;
        let left = this.leftSide == index;
        let right = this.rightSide == index;

        return [
          "promokit-slide__item",
          now && "promokit-slide__item--active",
          left && "promokit-slide__item--left",
          right && "promokit-slide__item--right",
        ];
      },

      now() {
        return this.nowIndex;
      },
    },
    mounted() {
      if (this.autoplay) {
        this.play();
      }
      document.documentElement.addEventListener("mousemove", this.handleMouseMove, true);
      document.documentElement.addEventListener("mouseup", this.handleMouseUp, true);
    },
    beforeDestroy() {
      document.documentElement.removeEventListener("mousemove", this.handleMouseMove, true);
      document.documentElement.removeEventListener("mouseup", this.handleMouseUp, true);
    },
  };
</script>

<template>
  <div class="promokit-slide" :style="contextStyle">
    <div class="promokit-slide__area"
         @mousedown.prevent="handleMouseDown"
         @touchstart.prevent="handleMouseDown"
         @touchmove.prevent="handleMouseMove"
         @touchend.prevent="handleMouseUp">

      <div class="promokit-slide__scroll"
           :style="scrollStyle"
           @transitionend.self="transitionEnd">

        <div v-for="(slide, index) in slideList"
             :id="`slide-${slideUid}-${index}`"
             :class="getClass(index)"
             :key="`slide-${slideUid}-${index}`">
          <slot :name="`slide${index}`"></slot>
        </div>

      </div>
    </div>

    <div class="promokit-slide__pagination" v-if="!noPagination && !disabled">
      <a v-for="(slide, index) in slideList"
         :key="`pagination-${slideUid}-${index}`"
         :href="`#slide-${slideUid}-${index}`"
         :class="[
           'promokit-slide__pagination-bullet',
           paginationCount == index && 'promokit-slide__pagination-bullet--active',
         ]"
         @click.prevent="to(index)">{{index+1}}번째 이미지 보기</a>
    </div>

    <button v-if="enableButton" class="promokit-slide__button promokit-slide__button--prev" @click.prevent="prev">이전 이미지 보기</button>
    <button v-if="enableButton" class="promokit-slide__button promokit-slide__button--next" @click.prevent="next">다음 이미지 보기</button>
  </div>
</template>

<style lang="scss">
  .promokit-slide {
    position: absolute;
    z-index: 10;
    &__img {
      user-select: none;
      border: 0;
      display: block;
    }

    &__video {
      top: 50%;
      position: absolute;
      left: 50%;
      transform: translateX(-50%) translateY(-50%);
      border: 0;
    }

    &__area {
      width: 100%;
      height: 100%;
      overflow: hidden;
      border:1px solid #585858;
    }

    &__scroll {
      height: 100%;
    }

    &__item {
      position: absolute;
      width: 100%;
      height: 100%;
      top: -200%;
      left: 0;
      z-index: 2;
      text-align: center;
      overflow: hidden;
      margin: 0;
      transform: translateZ(0);

      &--active {
        top: 0;
        z-index: 3;
      }

      &--left {
        top: 0;
        transform: translateX(-100%);
      }

      &--right {
        top: 0;
        transform: translateX(100%);
      }
    }

    &__button {
      position: absolute;
      top: 50%;
      width: 48px;
      height: 111px;
      z-index: 10;
      cursor: pointer;
      overflow: hidden;
      text-indent: -99em;
      outline: 0;
      border: 0;
      left: 50%;
      display:none;
      &--prev {
        margin-left: -850px;
       // @include bg($bg: 'img/detail/btn-detail-arrow.png', $position: 0 0);
      }

      &--next {
        margin-left: 802px;
       // @include bg($bg: 'img/detail/btn-detail-arrow.png', $position: -48px 0);
      }
    }

    &__pagination {
      width: 100%;
      position: absolute;
      bottom: -26px;
      text-align: center;


      &-bullet {
        text-indent: -999px;
        font-size:0;
        display:inline-block;
        background:#fff;
        vertical-align: middle;
        list-style-type: none;
        position: relative;
        width: 46px;
        height: 3px;
        margin: 0 7px;
        cursor: pointer;
        overflow: hidden;
        opacity: 1;
        outline: 0;
        border-radius: 5px;
       /* transition-property: width;
        transition-duration: .3s;
        transition-timing-function: ease-in-out;*/

        &--active {
         // width: 40px;
          background:#d0333c;
         transition-property: width;
          transition-duration: .3s;
          transition-timing-function: ease-in-out;
        }
      }
    }
  }
</style>
